import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import { ReconnectMoIcon, ReconnectQrIcon, ReconnectWkIcon, ReconnectYrIcon } from '@repo/icons';
import { AutoReconnectIcon, NoReconnectIcon } from '@repo/icons/Reconnect';
import { GroupReconnectCadence } from '@repo/utils/models/Group';
import styles from './GroupReconnect.module.scss';
import cn from 'classnames';
import { Overlay, Tooltip } from '@repo/components/tooltips';

export const cadenceOptions: Record<GroupReconnectCadence, { label: string; icon: React.FC<any> }> =
  {
    weekly: {
      label: 'Weekly',
      icon: ReconnectWkIcon,
    },
    monthly: {
      label: 'Monthly',
      icon: ReconnectMoIcon,
    },
    quarterly: {
      label: 'Quarterly',
      icon: ReconnectQrIcon,
    },
    yearly: {
      label: 'Yearly',
      icon: ReconnectYrIcon,
    },
    auto: {
      label: 'Auto',
      icon: AutoReconnectIcon,
    },
    disabled: {
      label: 'None',
      icon: NoReconnectIcon,
    },
  };

interface GroupReconnectProps {
  cadence: GroupReconnectCadence;
  onSelect: (cadence: GroupReconnectCadence) => void;
}

export default function GroupReconnect({ cadence, onSelect }: GroupReconnectProps) {
  return (
    <Section>
      <SectionTitle underline>Reconnect</SectionTitle>
      <div className={styles.sectionDescription}>Adjust the Reconnect cadence of this group.</div>
      <ul className={styles.list}>
        {Object.entries(cadenceOptions).map(([key, { label, icon: IconComponent }]) => (
          <li key={key} className={cn(styles.cadence, cadence === key && styles.selected)}>
            <Tooltip placement={'bottom'} overlay={<Overlay>{label}</Overlay>}>
              <button
                type="button"
                className={styles.button}
                onClick={() => onSelect(key as GroupReconnectCadence)}
              >
                <IconComponent className={styles.icon} />
              </button>
            </Tooltip>
          </li>
        ))}
      </ul>
    </Section>
  );
}
